module.exports = __webpack_public_path__ + "img/aba_yes.0998f1c4.png";